import React, { useEffect, useState } from "react";
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Toolbar,
  Typography,
} from "@mui/material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import moment from "moment";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { BASE_URL } from "../../global";
import axiosWithToken from "../../utils/components/axiosTokenConfig";
import { toast } from "react-toastify";
import ErrorModal from "../../utils/components/errorModal";
import Tables from "../../utils/components/tables";
import DownloadPdfLoaderModal from "../../utils/components/downloadPdfLoader";
import ExcelDownload from "../../utils/components/excelDownload";
import { useSearchParams } from "react-router-dom";
import ListWrap from "../commonComponent/listWrap";

var columns = [
  {
    id: "id",
    label: "Sr.No.",
    align: "left",
    minWidth: 40,
  },
  {
    id: "standardName",
    label: "EQP Name",
    align: "left",
    minWidth: 40,
  },
  {
    id: "stId",
    label: "Standard Id",
    align: "left",
    minWidth: 40,
  },
  {
    id: "companyName",
    label: "Client Name",
    align: "left",
    minWidth: 40,
  },

  {
    id: "address",
    label: "Client Address",
    align: "left",
    minWidth: 40,
  },
  {
    id: "outwardDate",
    label: "Outward Date",
    align: "left",
    minWidth: 40,
  },
  {
    id: "expectedReturnDate",
    label: "Expected Return Date",
    align: "left",
    minWidth: 40,
  },
  {
    id: "returnDate",
    label: "Return Date",
    align: "left",
    minWidth: 40,
  },
  {
    id: "engineerName",
    label: "Engineers Name",
    align: "left",
    minWidth: 40,
  },
];

let notNeededColumn = ["id", "standardId", "clientId", "lastModified","currentLocation","userId","status"];

const InOutReportList = () => {
  const [searchParams] = useSearchParams();
  const idsString = searchParams.get('ids');
  const  ids = JSON.parse(idsString) || [];
  const printComponentRef = React.useRef();
  const [selectStandards, setSelectStandards] = useState(ids.join(","));
  const [standardArr, setStandardArr] = useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(30);
  const [searchBy, setSearchBy] = React.useState("DUCID");
  const [searchKey, setSearchKey] = React.useState("");
  const [totalRows, setTotalRows] = React.useState(0);
  const [errormodalIsOpen, setErrorModalIsOpen] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState(null);
  const [finalData, setFinalData] = React.useState([]);
  const [downloadPdfloading, setDownlaodPdfLoading] = React.useState(false);
  const [initialRender, setInitialRender] = React.useState(true);
  const openErrorModal = (errorMessage, stackTrace, fileName) => {
    setErrorMessage({ errorMessage, stackTrace, fileName });
    setErrorModalIsOpen(true);
  };
  const closeErrorModal = () => {
    setErrorModalIsOpen(false);
  };

  const getStandardList = () => {
    let url = BASE_URL;
     let query = { query: `SELECT * FROM standards s WHERE s.id = (SELECT MAX(s2.id) FROM standards s2 WHERE s2.stId = s.stId and s2.status = 1) AND s.status = 1` };
    
    axiosWithToken
    .post(url + `dynamic`, query)
    // axiosWithToken
    //   .get(url + "standards?_where=(status,eq,1)")
      .then((res) => {
        const standardList = [];
        for (let i = 0; i < res.data.length; i++) {
          if (res.data[i].standardName != null)
            standardList.push({
              id: res.data[i].id,
              label: res.data[i].standardName,
              stId: res.data[i].stId,
            });
        }
        setStandardArr(standardList);
      })
      .catch((error) => {
        if (error.message !== "request_aborted") {
            toast.error("Something Went Wrong!");
          }
      });
  };

  const getQuery = (count) => {
    let whereConditions = "";
    let pagination_settings = "";

    if (searchBy !== "" && searchKey != "") {
      let colName = {
        "	Client Name": "companyName",
        "Instrument Name": "instrumentName",
        "Location Of Instrument": "locationOfInstrument",
        Department: "department",
        DUCID: "DUCID",
        "Serial Number": "serialNumber",
        Model: "model",
      }[searchBy];
      whereConditions = `where LOWER(${colName}) like LOWER('%${searchKey}%')`;
    }

    // if (_userType == 3)
    //   whereConditions +=
    //     whereConditions.length > 0
    //       ? `and cert.clientId = ${_clientId}`
    //       : `and cert.clientId = ${_clientId}`;
    // whereConditions +=
    //   whereConditions.length > 0
    //     ? " AND cert.status = 1"
    //     : "AND cert.status = 1";

    if (rowsPerPage != -1) {
      pagination_settings = `limit ${rowsPerPage} offset ${
        rowsPerPage * Number(page)
      }`;
    }

    let data = {
      query: `SELECT s.*, c.companyName, a.address, st.standardName, st.stId, (SELECT GROUP_CONCAT(u.userName SEPARATOR ', ') FROM users u WHERE FIND_IN_SET(u.id, s.userId) > 0) AS engineerName  FROM standardInOut s LEFT JOIN clients c ON s.clientId = c.id LEFT JOIN addresses a ON SUBSTRING_INDEX(s.address, ',', 1) = a.id LEFT JOIN standards st ON s.standardId = st.id WHERE s.standardId IN (${selectStandards}) ${whereConditions}  order by id DESC ${pagination_settings}`,
    };

    if (count)
      data.query = `SELECT COUNT(*) AS no_of_rows  FROM standardInOut s LEFT JOIN clients c ON s.clientId = c.id LEFT JOIN addresses a ON SUBSTRING_INDEX(s.address, ',', 1) = a.id LEFT JOIN standards st ON s.standardId = st.id WHERE s.standardId IN (${selectStandards}) ${whereConditions}`;
    return data;
  };

  // api calls
  function getTotalRows() {
    let data = getQuery(true);

    axiosWithToken
      .post(BASE_URL + `dynamic`, data)
      .then(async (res) => {
        setTotalRows(res.data[0]?.no_of_rows);
      })
      .catch((err) => {
        console.log("datasheet data fetching error: ", err);
        if (err.message !== "request_aborted") {
          toast.error(
            <h6
              onClick={() =>
                openErrorModal(err.message, "getTotalRows", "InOut Report")
              }
            >
              <u>Error: {err.message}</u>
            </h6>
          );
        }
      });
  }

  function fetchFinalData() {
    setInitialRender(false)
    getTotalRows();
    let data = getQuery();

    axiosWithToken
      .post(BASE_URL + `dynamic`, data)
      .then((res) => {
        setFinalData(res.data);
      })
      .catch((err) => {
        console.log("srfs data fetching error: ", err);
        if (err.message !== "request_aborted") {
          toast.error(
            <h6
              onClick={() =>
                openErrorModal(err.message, "fetchFinalData", "InOut Report")
              }
            >
              <u>Error: {err.message}</u>
            </h6>
          );
        }
      });
  }


  const generatePDF = () => {
    setDownlaodPdfLoading(true);

    try {
      const doc = new jsPDF({
        orientation: "p",
        unit: "pt",
        format: "a4",
        compress: true,
      });

      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();

      // 🔹 Page margins
      const margin = {
        top: 70,
        bottom: 30,
        left: 20,
        right: 20,
      };

      // 🔹 Title
      doc.setFont("helvetica", "bold");
      doc.setFontSize(14);
      doc.text(
        "MASTER IN OUT REPORT",
        pageWidth / 2,
        40,
        { align: "center" }
      );

      autoTable(doc, {
        startY: margin.top,
        pageBreak: "auto",
        rowPageBreak: "avoid",

        margin: margin,

        head: [columns.map(col => col.label)],

        body: finalData.map((row, index) => ([
          index + 1,
          row.standardName || "",
          row.stId || "",
          row.companyName || "",
          row.address || "",
          row.outwardDate
            ? moment(row.outwardDate).format("DD-MM-YYYY")
            : "",
          row.expectedReturnDate
            ? moment(row.expectedReturnDate).format("DD-MM-YYYY")
            : "",
          row.returnDate
            ? moment(row.returnDate).format("DD-MM-YYYY")
            : "",
          row.engineerName || "",
        ])),

        theme: "grid",
        styles: {
          fontSize: 8,
          cellPadding: 4,
          overflow: "linebreak",
          valign: "middle",
          lineWidth: 0.1,
          halign: "center",
          textColor: "black",
        },
        headStyles: {
          fillColor: false,
          textColor: "black",
          fontStyle: "bold",
          halign: "center",
        },
        didDrawPage: (data) => {
          // 🔹 Footer with page number
          const pageNo = doc.internal.getCurrentPageInfo().pageNumber;
          const totalPages = doc.internal.getNumberOfPages();

          doc.setFontSize(9);
          doc.setFont("helvetica", "normal");

          doc.text(
            `Page ${pageNo} of ${totalPages}`,
            pageWidth - margin.right,
            pageHeight - 20,
            { align: "right" }
          );
        },
      });

      doc.save("InOutReport.pdf");
    } catch (error) {
      console.error("PDF Error:", error);
    } finally {
      setDownlaodPdfLoading(false);
    }
  };

  const actions = [];

  useEffect(() => {
    getStandardList();
  }, []);

  useEffect(() => {
    if(!initialRender){
      fetchFinalData();
  }
  }, [page, rowsPerPage]);


  useEffect(() => {
    if(ids?.length > 0) fetchFinalData();
  }, [ids]);
 

  return (
    <ListWrap>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 1.5,
          alignItems: "flex-end",
          justifyContent: "flex-start",
          py: 0.625,
        }}
      >
        <Box sx={{ flex: { xs: "1 1 100%", md: "0 0 350px" }, maxWidth: { xs: "100%", md: 350 } }}>
          <Autocomplete
            multiple
            id="outlined-basic"
            size="small"
            className="Listinputcss"
            options={standardArr}
            value={standardArr?.filter((ele)=>selectStandards?.split(",")?.map(Number)?.includes(ele.id)) || null}
            disableCloseOnSelect
            getOptionLabel={(option) => `${option.stId} : ${option.label}` || ""}
            renderOption={(props, option, { selected }) => (
              <li {...props}>
                <Checkbox
                  icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                  checkedIcon={<CheckBoxIcon fontSize="small" />}
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
                {option.stId}: {option.label}
              </li>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Standards"
                placeholder="select multiple Standards"
              />
            )}
            onChange={(event, value) => {
              const selectedIds = value.map((option) => option.id).join(",");
              setSelectStandards(selectedIds);
            }}
          />
        </Box>
        <Box>
          <Button
            variant="contained"
            size="small"
            onClick={() => {
              fetchFinalData()
            }}
          >
            Prepare Data
          </Button>
        </Box>
        <Box>
          <Button
            variant="contained"
            size="small"
            onClick={() => {
              generatePDF();
            }}
          >
            Download PDF
          </Button>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "stretch",
            "& > div > button": {
              marginLeft: "0px !important",
            },
          }}
        >
          <ExcelDownload
            finalData={finalData}
            notNeededColumn={notNeededColumn}
          />
        </Box>
      </Box>
      <div style={{ marginTop: "30px" }}>
        <Tables
          page={page}
          setPage={setPage}
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
          // handleDelete={handleDelete}
          columns={columns}
          finalData={finalData}
          actions={actions}
          totalRows={totalRows}
          printComponentRef={printComponentRef}
          isPrint={true}
        />
        <div style={{ width: "100%" }} id="header-section"></div>
      </div>

      {errormodalIsOpen && (
        <ErrorModal
          errormodalIsOpen={errormodalIsOpen}
          closeErrorModal={closeErrorModal}
          errorMessage={errorMessage}
        />
      )}
      {downloadPdfloading && (
        <DownloadPdfLoaderModal
          loading={downloadPdfloading}
          name={"Master IN OUT"}
        />
      )}
    </ListWrap>
  );
};

export default InOutReportList;
